// extracted by mini-css-extract-plugin
module.exports = {"baseNull":"BaseNull_baseNull_1ZIJ0"};